import { render, staticRenderFns } from "./educationDivision5.vue?vue&type=template&id=30621ef6"
import script from "./educationDivision5.vue?vue&type=script&lang=js"
export * from "./educationDivision5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30621ef6')) {
      api.createRecord('30621ef6', component.options)
    } else {
      api.reload('30621ef6', component.options)
    }
    module.hot.accept("./educationDivision5.vue?vue&type=template&id=30621ef6", function () {
      api.rerender('30621ef6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/div/educationDivision5.vue"
export default component.exports